import "core-js/modules/es.array.push.js";
import { questionnaireList } from './request';
export default {
  data() {
    return {
      form: {},
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'serialNo',
        key: '1',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '问卷名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        width: 220,
        key: '6',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        }
      }],
      data: []
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    async getDataFun() {
      const {
        items,
        totalNum
      } = await questionnaireList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.data = items;
      this.pagination.total = totalNum;
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.data = [];
      this.getDataFun();
    },
    // 填写页面
    handleEdit(record) {
      // console.log('获取点击的值', record);
      this.$router.push({
        name: 'questionModer',
        params: {
          id: record.auditFlowId
        }
      });
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    }
  }
};